import archive from '@/assets/data/special-projects/archive';
import heroes from '@/assets/data/special-projects/heroes';
import hockey from '@/assets/data/special-projects/hockey';
import images from '@/assets/data/special-projects/images';
import journal from '@/assets/data/special-projects/journal';

export default {
  heroes,
  images,
  hockey,
  journal,
  archive,
};
